/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useFunilConcorrentes = ({ formikRef, name = "funilObraConcorrenteId" }) => {
  const funilConcorrenteSelect = useSelect(name);
  const [funilConcorrente, setFunilConcorrente] = useState(0);

  const [funilConcorrentes, setFunilConcorrentes] = useState([]);

  useEffect(() => {
    const fetchConcorrentes = async () => {
      const result = [];
      await db.funilObraConcorrente.each((item) => result.push(item));
      setFunilConcorrentes(result);
    };

    fetchConcorrentes();
  }, []);

  const optionFunilConcorrentes = useMemo(() => prepareForOptions(funilConcorrentes, ['nome'], 'id'), [funilConcorrentes]);

  function onChangeFunilConcorrente(e) {
    funilConcorrenteSelect.upDateValue(e.value);
    funilConcorrenteSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setFunilConcorrente(e.value);
  }

  function setSelectConcorrente(id) {
    const funilConcorrente = optionFunilConcorrentes.find((o) => o.value === id);
    if (funilConcorrente)
      onChangeFunilConcorrente(funilConcorrente);
  }

  const concorrenteSelecionado = useMemo(() => {
    if(funilConcorrente && funilConcorrente != 0)
      return funilConcorrentes?.find(e => e.id == funilConcorrente);
    return null;
  }, [funilConcorrente])

  return {
    concorrenteSelecionado,
    funilConcorrentes,
    optionFunilConcorrentes,
    onChangeFunilConcorrente,
    setSelectConcorrente,
    funilConcorrente,
    funilConcorrenteSelect,
    setFunilConcorrente
  };
}

export default useFunilConcorrentes;